module.exports = __webpack_public_path__ + "static/conversion-3fa7d9be2f5ab426e2a09e3bc133ff33.svg";